
import React, { Component, Fragment, useEffect, useState, useContext } from "react";
import { SessionContext } from "../../../context/SessionProvider";



import BiCheckBox from '../../uic/controls/BiCheckBox';
import BiTextBox from '../../uic/controls/BiTextBox';
import BiLabel from '../../uic/controls/BiLabel';
import BiDatePicker from '../../uic/controls/BiDatePicker';

import BiFormTable from '../../uic/formTable/BiFormTable';
import BiFormRow from '../../uic/formTable/BiFormRow';
import BiFormCell from '../../uic/formTable/BiFormCell';
import BiFormSection from '../../uic/formTable/BiFormSection';
import BiCheckBoxList from "../../uic/controls/BiCheckBoxList";
import BiTextArea from "../../uic/controls/BiTextArea";
import useFetch from "../../helpers/useFetch";
import BiComboBox from "../../uic/controls/BiComboBox";
import BiAutoCB from "../../uic/controls/BiAutoCB";
import BiFileUpload from "../../uic/controls/BiFileUpload";
import BiDataGrid from "../../uic/dataGrid/BiDataGrid";

const SemenskiMaterialObrazec = ({
    idObrazca,
    obrazec,
    idStatus,
    onObrazecChanged,

    onObrazecCBListChanged,

    onObrazecTableChange,
    onObrazecTableAdd,
    onObrazecTableRemove,

    admin,
    disabled,
    onObrazecDatotekeAdd,
    onObrazecDatotekeRemove,
    
}) => {

    const { data: vrste } = useFetch('api/semenskiMaterial/GetSMSifrant');
    const { data: sorte, setUrl: setSorteURL } = useFetch('api/semenskiMaterial/GetSMSifrant?PIdSemenskiMaterialVrsta=1');
    const { data: em, setUrl: setEMURL } = useFetch('api/semenskiMaterial/GetEMSifrant');
    const { data: razlogi } = useFetch('api/sifranti/GetSifrantNA?all=true&ID=RAZLOG-DOKUPA', true);

    const disabledFun = () => {
        return disabled;
    }

    const onKolicinaSelectionChanged = (item) => {
        setSorteURL('api/semenskiMaterial/GetSMSifrant?PIdSemenskiMaterialVrsta=' + item.sifVrsta.id);
      
        setEMURL('api/semenskiMaterial/GetEMSifrant?PIdSemenskiMaterialVrsta=' + item.sifVrsta.id);
    }

    const preveriVnos = (item) => {
        
            if ((item.sifSorta.naziv == null || item.sifSorta.naziv == "")) {
                return false;
            } else {
                return true;
            }
    
    }

    const current = new Date();

    const preveriVnosAdmin = (item) => {
        if (admin) { return true; }
        if ((item.sifSorta.naziv == null || item.sifSorta.naziv == "")) {
            return false;
        } else {
            return true;
        }

    }

    const isCSelected = () => {

        var CItems = obrazec.kolicine.filter(o => o.sifRazlogDokupa.naziv == "C");
        return CItems.length > 0;
    }

    const isCSelectedObvezno = () => {

        var CItems = obrazec.kolicine.filter(o => o.sifRazlogDokupa.naziv == "C");
        if (CItems.length > 0 && (obrazec.cOpomba == null || obrazec.cOpomba == ""))
            return { border: "1px solid red", borderRadius: "4px" };
    }

    const obvezniPodatki = (item) => {
        
        if (item.napakaPriVnosu == true) {
            return { color: "red", borderRight: "2px solid red" };
        }
        return null;
    }

    const getColumns = () => {

        if (admin) {

            return [
                { label: "ID", key: "pIdSemenskiMaterialObrazecKolicine", type: "decimal", width: "50px" },
                { label: "Vrsta", key: "sifVrsta", type: "comboBox", items: { items: vrste }, width: "120px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Sorta", key: "sifSorta", type: "comboBox", items: { items: sorte }, width: "120px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Nova sorta", key: "sorta", type: "string", width: "100px", editable: true, disabled: preveriVnos, cellStyleFun: obvezniPodatki },
                { label: "Količina", key: "kolicina", type: "decimal", width: "100px", format: "0.00[0000]", align: "right", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Enota mere", key: "sifEnoraMere", type: "comboBox", items: { items: em }, width: "100px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Datum setve/sajenja", key: "datumSetve", type: "date", width: "140px", editable: !disabled,  cellStyleFun: obvezniPodatki },
                { label: "Razlog dokupa*", key: "sifRazlogDokupa", type: "comboBox", items: { items: razlogi }, width: "110px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Odobreno", key: "odobreno", type: "checkBox", width: "80px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Razlog zavrnitve", key: "razlogZavrnitve", type: "string", width: "250px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { width: "100%" }
            ];
        }
            else if (!admin && idStatus > 2) {
            return [
                { label: "ID", key: "pIdSemenskiMaterialObrazecKolicine", type: "decimal", width: "50px" },
                { label: "Vrsta", key: "sifVrsta", type: "comboBox", items: { items: vrste }, width: "120px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Sorta", key: "sifSorta", type: "comboBox", items: { items: sorte }, width: "120px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Nova sorta", key: "sorta",  type: "string", width: "100px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Količina", key: "kolicina", type: "decimal", width: "100px", format: "0.00[0000]", align: "right", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Enota mere", key: "sifEnoraMere", type: "comboBox", items: { items: em }, width: "100px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Datum setve/sajenja", key: "datumSetve", type: "date", width: "140px", editable: !disabled, minDate: new Date().setDate(new Date().getDate() - 1), cellStyleFun: obvezniPodatki },
                { label: "Razlog dokupa*", key: "sifRazlogDokupa", type: "comboBox", items: { items: razlogi }, width: "110px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Odobreno", key: "odobreno", type: "checkBox", width: "80px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Razlog zavrnitve", key: "razlogZavrnitve", type: "string", width: "250px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { width: "100%" }
            ];
        }
         else {
            return [
                { label: "ID", key: "pIdSemenskiMaterialObrazecKolicine", type: "decimal", width: "50px" },
                { label: "Vrsta", key: "sifVrsta", type: "comboBox", items: { items: vrste }, width: "120px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Sorta", key: "sifSorta", type: "comboBox", items: { items: sorte }, width: "120px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Nova sorta", key: "sorta", type: "string", width: "100px", editable: true, disabled: preveriVnos, cellStyleFun: obvezniPodatki },
                { label: "Količina", key: "kolicina", type: "decimal", width: "100px", format: "0.00[0000]", align: "right", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Enota mere", key: "sifEnoraMere", type: "comboBox", items: { items: em }, width: "100px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { label: "Datum setve/sajenja", key: "datumSetve", type: "date", width: "140px", editable: !disabled, minDate: new Date().setDate(new Date().getDate() - 1), cellStyleFun: obvezniPodatki },
                { label: "Razlog dokupa*", key: "sifRazlogDokupa", type: "comboBox", items: { items: razlogi }, width: "110px", editable: !disabled, cellStyleFun: obvezniPodatki },
                { width: "100%" }

            ];
        }
    }

    return (

        <Fragment >

            {obrazec &&


                <form className="form">

                   
                    <BiFormTable responsive={true} columns={[
                        { width: "col-lg-2" },
                        { width: "col-lg-6" },
                        { width: "col-lg-2" },
                    ]}>
                        {admin &&
                            <BiFormSection responsive={true} show={true} label="Osnovni podatki" icon="fas fa-calendar-plus" >
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                                <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-regular fa-user">Obdelal:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true} >
                                        <BiTextBox name="potrdil" disabled="true" value={obrazec.potrdil} onChange={onObrazecChanged} ></BiTextBox>

                                    </BiFormCell>
                                </BiFormRow>
                                
                               
                                <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} ><BiLabel icon="fas fa-book-reader">Naziv:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true} >
                                        <BiTextBox maxlength="255" disabled="true" name="naziv" value={obrazec.nazivStranke} onChange={onObrazecChanged} ></BiTextBox>

                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} ><BiLabel icon="fa-solid fa-calendar-days">Datum obravnave:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true} >
                                        <BiDatePicker name="datumObravnave" value={obrazec.datumObravnave ?? new Date()} onChange={onObrazecChanged} ></BiDatePicker>

                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                            </BiFormSection>
                        }
                        {!admin &&
                            <BiFormSection responsive={true} show={true} label="Osnovni podatki" icon="fas fa-calendar-plus" >
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                                <BiFormRow responsive={true} >
                                    <BiFormCell responsive={true} ><BiLabel icon="fas fa-book-reader">Podpisnik:</BiLabel></BiFormCell>
                                    <BiFormCell responsive={true} >
                                        <BiTextBox maxlength="255" name="podpisnik" value={obrazec.podpisnik} onChange={onObrazecChanged} disabled={disabled} ></BiTextBox>

                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow responsive={true} divider={true}></BiFormRow>
                            </BiFormSection>
                        }
                        <BiFormSection responsive={true} show={true} label="Vnos kultur" icon="fas fa-calendar-plus" >

                            <BiFormRow responsive={true} divider={true}></BiFormRow>
                            <BiFormRow responsive={true} >

                                <BiFormCell responsive={true} col="col-lg-12" >
                                    <div style={{ minHeight: "310px" }} >
                                        <BiDataGrid

                                            items={obrazec.kolicine}
                                            name="kolicine"
                                            mainKey="pIdSemenskiMaterialObrazecKolicine"
                                            onSelectedItemChanged={onObrazecTableChange}

                                            urlParams={{ id: obrazec.pIdSemenskiMaterialObrazec }}

                                            addUrl="api/SemenskiMaterial/DodajKolicino"
                                            onAdd={onObrazecTableAdd}

                                            removeUrl="api/SemenskiMaterial/BrisiKolicino"
                                            onRemove={onObrazecTableRemove}

                                            onSelectionChanged={onKolicinaSelectionChanged}

                                            columns={getColumns()}
                                            disabled={disabled}
                                        ></BiDataGrid>
                                    </div>
                                </BiFormCell>
                            </BiFormRow>
                            <BiFormRow responsive={true} divider={true}></BiFormRow>
                        </BiFormSection>

                        <BiFormSection responsive={true} show={true} label="Razlog dokupa" icon="fas fa-comment" >
                            <BiFormRow responsive={true} divider={true}></BiFormRow>
                            <BiFormRow responsive={true} >
                                <BiFormCell responsive={true} col="col-lg-16">
                                    <BiLabel><b>*Dovoljenje za uporabo netretiranega razmnoževalnega materiala, ki ni pridelano s postopkom ekološke pridelave, se lahko izda le v naslednjih primerih:</b></BiLabel>
                                    <BiLabel>A.	Nobena sorta vrste ni registrirana v podatkovni zbirki ekološkega razmnoževalnega materiala, ki je objavljena na <a href="https://www.gov.si/assets/ministrstva/MKGP/PODROCJA/KMETIJSTVO/Ekolosko_kmetovanje/PODATKOVNA-ZBIRKA-EKO-SEMENA/2025/1-Podatkovna-zbirka-ekoloskega-semenskega-materiala-ki-velja-od-14.februarja-2025.xls">spletni strani MKGP.</a></BiLabel>
                                    <BiLabel>B.	Ekološki razmnoževalni material ni dobavljiv s strani dobaviteljev, ki so navedeni v podatkovni zbirki MKGP, navkljub pravočasnemu naročilu.
                                        Priloga: <b>Obvezno pisno potrdilo dobavitelja</b>, o nedobavljivosti ekološkega razmnoževalnega materiala, ki je naveden v <a href="https://www.gov.si/assets/ministrstva/MKGP/PODROCJA/KMETIJSTVO/Ekolosko_kmetovanje/PODATKOVNA-ZBIRKA-EKO-SEMENA/2025/1-Podatkovna-zbirka-ekoloskega-semenskega-materiala-ki-velja-od-14.februarja-2025.xls">podatkovni zbirki MKGP.</a></BiLabel>
                                    <BiLabel>C. Sorta ni registrirana v <a href="https://www.gov.si/assets/ministrstva/MKGP/PODROCJA/KMETIJSTVO/Ekolosko_kmetovanje/PODATKOVNA-ZBIRKA-EKO-SEMENA/2025/1-Podatkovna-zbirka-ekoloskega-semenskega-materiala-ki-velja-od-14.februarja-2025.xls">podatkovni zbirki MKGP.</a>Izvajalec dejavnosti pa lahko dokaže, da nobena registrirana alternativa iste vrste ni primerna, in sicer zlasti za agronomske, talne in podnebne razmere ter za tehnološke lastnosti, potrebne za načrtovano proizvodnjo, in da je zato odobritev za njegovo proizvodnjo pomembna, (obvezen razlog), ker: </BiLabel>
                                    <BiTextArea maxlength="4000" disabled={disabled || !isCSelected()} name="cOpomba" value={obrazec.cOpomba} onChange={onObrazecChanged} style={isCSelectedObvezno()}></BiTextArea>
                                    <BiLabel>D.	Kadar je to upravičeno za uporabo v raziskavah, za testiranje majhnega obsega v terenskih poskusih, za namen ohranjanja sort ali inovativne proizvode ter kadar uporabo odobrijo pristojni organi zadevne države članice. Priloga: dovoljenje</BiLabel>
                                </BiFormCell>
                            </BiFormRow>
                        </BiFormSection>
                        <BiFormRow responsive={true} divider={true}></BiFormRow>
                        <BiFormRow responsive={true} divider={true}></BiFormRow>
                        <BiFormRow responsive={true} divider={true}></BiFormRow>
                        <BiFormRow responsive={true} divider={true}></BiFormRow>
                    </BiFormTable>
                </form>


            }
        </Fragment>
    );

}

export default SemenskiMaterialObrazec;